import Button from "common/components/Button/Button"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputSwitch from "common/components/FormikFields/FormikInputSwitch"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { validateEmail, validateTelefono } from "common/utils/formValidations"
import {
  FORMAS_DE_CONTACTO,
  OPTIONS_FORMAS_CONTACTO,
} from "features/Contactos/constants"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import {
  createFormaContactoEmpresa,
  deleteFormaContactoEmpresa,
  updateFormaContactoEmpresa,
} from "../../../redux/slices/empresaSlice"

const FormContacto = ({
  handleSubmit,
  deleteFormaContactoEmpresa,
  isSubmitting,
  values,
  initialValues,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const handleDeleteContacto = () => {
    deleteFormaContactoEmpresa(initialValues)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className='p-fluid p-formgrid p-grid'>
        <div className='text-left p-field col-md-12 col-lg-4'>
          <label>{t("perfilEmpresa.contact.perfilEmpresa")}</label>
          <FormikDropdown
            placeholder={`${t(
              "perfilEmpresa.contact.placeholderContactForma"
            )}`}
            options={OPTIONS_FORMAS_CONTACTO(t)}
            id='tipoFormaContacto'
            value={values.tipoFormaContacto}
            name='tipoFormaContacto'
          />
        </div>

        <div className='text-left p-field col-md-12 col-lg-4'>
          <label id='contactoInput'>
            {t("perfilEmpresa.contact.labelContact")}
          </label>
          <FormikInputText
            id='contactoInput'
            name='contacto'
          />
        </div>

        <div className='text-left p-field col-md-12 col-lg-4 d-flex contact-input'>
          <FormikInputSwitch
            id='inputPrincipal'
            name='principal'
          />
          <label
            className='mb-1 ml-2'
            id='inputPrincipal'
          >
            {t("perfilEmpresa.contact.labelContactPrincipal")}
          </label>
        </div>
      </div>

      <div className='ml-2 align-items-center d-flex justify-content-start'>
        <Button
          className='!tw-bg-primary'
          loading={isSubmitting}
          type='submit'
        >
          {t("perfilEmpresa.contact.buttonSave")}
        </Button>
        <Button
          onClick={handleDeleteContacto}
          className='ml-4 text-red text pointer'
        >
          {t("perfilEmpresa.contact.buttonDelete")}
        </Button>
      </div>
    </form>
  )
}

const mapValuesToApi = (values: $TSMigrationFixMe) => ({
  tipoFormaContacto: values?.tipoFormaContacto,
  principal: values?.principal,
  nuevo: values?.nuevo,
  contacto: values?.contacto,
  id: values?.id,
  empresaId: values?.empresaId,
})

const CONTACTO_VALIDATIONS = (t: $TSMigrationFixMe) => {
  return {
    [FORMAS_DE_CONTACTO.EMAIL]: validateEmail(t),
    [FORMAS_DE_CONTACTO.MOVIL]: validateTelefono(t),
    [FORMAS_DE_CONTACTO.TELEFONO]: validateTelefono(t),
  }
}

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    tipoFormaContacto: Yup.number()
      .nullable()
      .required(t("errors.selectClientType")),
    contacto: Yup.string()
      .required(t("errors.contactEmpty"))
      .ensure()
      .when("tipoFormaContacto", (tipoFormaContacto) => {
        return CONTACTO_VALIDATIONS(t)[tipoFormaContacto]
      }),
  })

const Actividad = withFormik({
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, empresaId }) => ({
    id: data?.id,
    contacto: data?.contacto,
    principal: data?.principal,
    tipoFormaContacto: data?.tipoFormaContacto,
    nombre: data?.nombre,
    nuevo: data?.nuevo,
    empresaId,
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props, setSubmitting }) => {
    const data = mapValuesToApi(values)

    setSubmitting(true)
    try {
      if (values.nuevo) {
        // @ts-expect-error TS(2339): Property 'createFormaContactoEmpresa' does not exi...
        await props.createFormaContactoEmpresa(data)
      } else {
        // @ts-expect-error TS(2339): Property 'changeActividadContacto' does not exist ...
        await props.changeActividadContacto(data)
      }

      setSubmitting(false)
    } catch (e) {
      setSubmitting(false)
    }
  },
})(FormContacto)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  changeActividadContacto: (payload: $TSMigrationFixMe) =>
    dispatch(updateFormaContactoEmpresa(payload)),
  deleteFormaContactoEmpresa: (payload: $TSMigrationFixMe) =>
    dispatch(deleteFormaContactoEmpresa(payload)),
  createFormaContactoEmpresa: (payload: $TSMigrationFixMe) =>
    dispatch(createFormaContactoEmpresa(payload)),
})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Actividad)
